export enum Modals {
  AboutUs = 'AboutUs',
  Login = 'Login',
  Deposit = 'Deposit',
  Registration = 'Registration',
  BecomeVip = 'BecomeVip',
  Withdraw = 'Withdraw',
  Topics = 'Topics',
  Providers = 'Providers',
  ExchangeCompoints = 'ExchangeCompoints',
  Recovery = 'Recovery',
  ChooseAvatar = 'ChooseAvatar',
  TermsAndConditionsAcceptance = 'TermsAndConditionsAcceptance',
  SuperSpotDetails = 'SuperSpotDetails',
  ConfirmRegistration = 'ConfirmRegistration',
  GenderSelect = 'GenderSelect',
  LeaveDeposit = 'LeaveDeposit',
}

export const ModalQueryByName: Record<Modals, string> = {
  [Modals.AboutUs]: 'about-us',
  [Modals.Login]: 'login',
  [Modals.Deposit]: 'deposit',
  [Modals.Registration]: 'registration',
  [Modals.BecomeVip]: 'become-vip',
  [Modals.Withdraw]: 'withdraw',
  [Modals.Topics]: 'topics',
  [Modals.Providers]: 'providers',
  [Modals.ExchangeCompoints]: 'exchange-compoints',
  [Modals.Recovery]: 'recovery',
  [Modals.ChooseAvatar]: 'choose-avatar',
  [Modals.TermsAndConditionsAcceptance]: 'terms-and-conditions-acceptance',
  [Modals.SuperSpotDetails]: 'super-spot-details',
  [Modals.ConfirmRegistration]: 'confirm-registration',
  [Modals.GenderSelect]: 'gender-select',
  [Modals.LeaveDeposit]: 'leave-deposit',
};

export const NON_AUTH_MODALS_MAP: Modals[] = [
  // Modals.Registration,
  Modals.Login,
  Modals.Recovery,
];

export const AUTH_MODALS_MAP: Modals[] = [
  Modals.Deposit,
  Modals.LeaveDeposit,
  Modals.BecomeVip,
  Modals.Withdraw,
  Modals.ExchangeCompoints,
  Modals.ChooseAvatar,
  Modals.SuperSpotDetails,
  Modals.GenderSelect,
];

export const QUERY_VIP = 'vip';
export const MODAL_QUERY_KEY = 'modal';
